import { render, staticRenderFns } from "./InterfaceTextarea.vue?vue&type=template&id=7ec066ec"
import script from "./InterfaceTextarea.vue?vue&type=script&lang=js"
export * from "./InterfaceTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports